// Components==============
import { faSpinner } from '@fortawesome/pro-regular-svg-icons';
import { faCamera } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import updateUser from 'actions/user/update';
import Avatar from 'components/UI/Avatar/Avatar';
import { useAlert } from 'hooks/useAlert';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import { useTranslate } from 'hooks/useTranslate';
import React, { useState } from 'react';
import './ChangeAvatar.module.scss';
// =========================

export default function ChangeAvatar() {
  const translate = useTranslate();

  const dispatch = useReduxAction();
  const user = useRedux((state) => state.authentication?.user);

  const [loading, setLoading] = useState(false);

  const alert = useAlert();

  function handleFileUpload(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (!file?.type.includes('image/')) {
      alert(translate('general.image-upload-alert'));
      return;
    }
    setLoading(true);
    dispatch(updateUser({ id: user?.id, image: e.target.files?.[0] }))
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }

  return (
    <div styleName="wrapper">
      <input
        type="file"
        accept="image/*"
        id="btn"
        onChange={handleFileUpload}
        name="upload"
      />
      <label htmlFor="btn">
        <Avatar size="big" />
        <div styleName={`overlay ${loading ? 'is-loading' : ''}`}>
          <FontAwesomeIcon
            icon={loading ? faSpinner : faCamera}
            spin={loading}
          />
        </div>
      </label>
      <h3>{`${user?.first_name} ${user?.last_name}`}</h3>
    </div>
  );
}
